var levelOfAWSUsage = {
	"Level of AWS usage": "Cấp sử dụng AWS",
	"Do not use AWS today": "Không sử dụng AWS hôm nay",
	"Evaluating/experimenting with AWS": "Đánh giá/thử nghiệm với AWS",
	"Run dev/test workloads on AWS": "Chạy tải công việc phát triển/thử nghiệm trên AWS",
	"Run a production workload on AWS": "Chạy tải công việc sản xuất đơn lẻ trên AWS",
	"Run multiple production workloads on AWS": "Chạy nhiều tải công việc sản xuất trên AWS"
};

export { levelOfAWSUsage as default };
